import { render, staticRenderFns } from "./TournamentEndedSummary.vue?vue&type=template&id=7b8cf034&scoped=true"
import script from "./TournamentEndedSummary.vue?vue&type=script&lang=js"
export * from "./TournamentEndedSummary.vue?vue&type=script&lang=js"
import style0 from "./TournamentEndedSummary.vue?vue&type=style&index=0&id=7b8cf034&prod&lang=scss&scoped=true"
import style1 from "./TournamentEndedSummary.vue?vue&type=style&index=1&id=7b8cf034&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8cf034",
  null
  
)

export default component.exports